module.exports = __webpack_public_path__ + "img/dianshi.d0352bcf.png";